/**
 * Copies @see text to clipboard & puts user's selection back where it was.
 *
 * @note Falls back to `document.execCommand('copy')` when
 * @see navigator.clipboard.writeText is missing or rejects (incognito,
 * permissions, non-secure context).
 */
export async function copyToClipboard(text: string): Promise<void> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return;
    }
  } catch {
    // Fall through to execCommand.
  }

  copyWithExecCommand(text);
}

function copyWithExecCommand(text: string): void {
  const selection = window.getSelection();
  let oldRange: Range | null = null;
  if (selection && selection.rangeCount > 0) {
    oldRange = selection.getRangeAt(selection.rangeCount - 1).cloneRange();
  }

  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.top = '0';
  textarea.style.left = '-9999px';
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);

  selection?.removeAllRanges();
  if (oldRange) {
    selection?.addRange(oldRange);
  }
}
